import React, { FC } from 'react'
import cn from 'clsx'
import Link from 'components/ui/Link'

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  /**
   * Href of the link
   */
  href: string
  /**
   * Text of the link
   */
  text: string
  /**
   * Native props of the link
   */
  linkProps?: Omit<React.ComponentProps<typeof Link>, 'href'>
  /**
   * Additionnal class names
   */
  className?: string
  /**
   * Disable the link
   */
  disabled?: boolean
  /**
   * Button click action
   */
  onClick?: () => void
  /**
   * Button color scheme
   */
  colorScheme?: 'default' | 'transparent'
}

export const ButtonLink: FC<ButtonProps> = ({
  text,
  href,
  className,
  disabled,
  onClick,
  colorScheme = 'default',
  linkProps,
}) => {
  return (
    <button
      className={cn('h-14 font-bold uppercase', className, {
        'bg-grey': disabled,
        'hover:bg-deepPurple': disabled !== true,
        'bg-purple': colorScheme === 'default',
        'bg-transparent border border-white hover:border-0':
          colorScheme === 'transparent',
      })}
      onClick={onClick}
      disabled={disabled}
    >
      <Link
        href={href}
        className={cn(' p-2 flex justify-center items-center', {
          'cursor-default': disabled,
          'pointer-events-none': disabled,
        })}
        {...linkProps}
      >
        {text}
      </Link>
    </button>
  )
}
